import { asDecimal } from '@/lib/helpers/numeric'

/**
 * Convert temperature between Celsius, Fahrenheit, and Kelvin
 *
 * @param {number} value - Value to convert
 * @param {string} unitIn - Source unit ('C', 'F', or 'K')
 * @param {string} unitOut - Target unit ('C', 'F', or 'K')
 * @param {number|null} decimals - Number of decimals (null to disable)
 * @param {boolean} returnString - If true, return formatted string
 * @returns {object|string}
 */
export const convertDegree = (value, unitIn = 'C', unitOut = 'F', decimals = 2, returnString = false) => {
    unitOut = unitOut ?? 'C'

    let degree = {
        value: value,
        unit: unitIn,
    }

    if (unitIn !== unitOut) {
        switch (unitIn) {
            case 'K':
                if (unitOut === 'C') {
                    degree.value -= 273.15
                } else if (unitOut === 'F') {
                    degree.value = ((degree.value - 273.15) * 9) / 5 + 32
                }
                break
            case 'C':
                if (unitOut === 'K') {
                    degree.value += 273.15
                } else if (unitOut === 'F') {
                    degree.value = (degree.value * 9) / 5 + 32
                }
                break
            case 'F':
                if (unitOut === 'C') {
                    degree.value = ((degree.value - 32) * 5) / 9
                } else if (unitOut === 'K') {
                    degree.value = ((degree.value - 32) * 5) / 9 + 273.15
                }
                break
        }
        degree.unit = unitOut
    }

    degree.unit = '°' + degree.unit

    if (decimals !== null) {
        degree.value = asDecimal(degree.value, decimals)
    }

    return returnString ? `${degree.value}${degree.unit}` : degree
}
